let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aygcW")).then(() => parcelRequire('z08PO'));